// Utility function to get the API base URL dynamically
export const getApiBaseUrl = () => {
  // Use relative URLs so they work from any hostname
  return window.location.origin;
};

